@let configuration = configurationSg();
<!-- The occupants' layout also decides how their accounts are laid out -->
@let hasOccupantsOrAccounts =
  configuration.occupantFields.length > 0 ||
  configuration.accountFields.length > 0;

<div class="atn-space-report-data-export">
  <atn-ds-widget title="Filters">
    <div class="atn-space-report-data-export__content">
      <atn-ds-section name="Organization">
        <div class="atn-space-report-data-export__section">
          <atn-space-dimension-filter [plugin]="organizationFilterPlugin" />
        </div>
      </atn-ds-section>
      <atn-ds-section name="Space">
        <div class="atn-space-report-data-export__section">
          <atn-space-dimension-filter [plugin]="spaceFilterPlugin" />
        </div>
      </atn-ds-section>
      <atn-ds-section name="Clusters">
        <div class="atn-space-report-data-export__section">
          <atn-space-dimension-filter [plugin]="clusterFilterPlugin" />
        </div>
      </atn-ds-section>
    </div>
  </atn-ds-widget>

  <atn-ds-widget title="Fields">
    <div class="atn-space-report-data-export__content">
      <atn-ds-section name="Room">
        <div class="atn-space-report-data-export__section">
          <atn-ds-select-multiple
            placeholder="All fields"
            [config]="{ overlay: { hasSearch: true } }"
            [items]="fieldItemsSg()"
            [value]="configuration.fields"
            (valueChange)="fieldsChangeHandler($event)"
          />
        </div>
      </atn-ds-section>
      <atn-ds-section name="Occupants">
        <div class="atn-space-report-data-export__section">
          <atn-ds-select-multiple
            placeholder="None"
            [items]="occupantFieldItems"
            [value]="configuration.occupantFields"
            (valueChange)="occupantFieldsChangeHandler($event)"
          />
          <atn-ds-select-single
            label="Layout"
            [items]="layoutItems"
            [value]="configuration.occupantLayout"
            [required]="hasOccupantsOrAccounts"
            [disabled]="!hasOccupantsOrAccounts"
            (valueChange)="layoutChangeHandler({ occupantLayout: $event })"
          />
        </div>
      </atn-ds-section>
      <atn-ds-section name="Accounts">
        <div class="atn-space-report-data-export__section">
          <atn-ds-select-multiple
            placeholder="None"
            [items]="accountFieldItems"
            [value]="configuration.accountFields"
            (valueChange)="accountFieldsChangeHandler($event)"
          />
          <atn-ds-select-single
            label="Layout"
            [items]="layoutItems"
            [value]="configuration.accountLayout"
            [required]="configuration.accountFields.length > 0"
            [disabled]="configuration.accountFields.length === 0"
            (valueChange)="layoutChangeHandler({ accountLayout: $event })"
          />
        </div>
      </atn-ds-section>
      <atn-ds-section name="Responsible Persons">
        <div class="atn-space-report-data-export__section">
          <atn-ds-select-multiple
            placeholder="None"
            [items]="responsiblePersonFieldItems"
            [value]="configuration.responsiblePersonFields"
            (valueChange)="responsiblePersonFieldsChangeHandler($event)"
          />
          <atn-ds-select-single
            label="Layout"
            [items]="layoutItems"
            [value]="configuration.responsiblePersonLayout"
            [required]="configuration.responsiblePersonFields.length > 0"
            [disabled]="configuration.responsiblePersonFields.length === 0"
            (valueChange)="
              layoutChangeHandler({ responsiblePersonLayout: $event })
            "
          />
        </div>
      </atn-ds-section>
      <atn-ds-section name="Functional Usage">
        <div class="atn-space-report-data-export__section">
          <atn-ds-select-multiple
            placeholder="None"
            [items]="functionalUsageFieldItems"
            [value]="configuration.functionalUsageFields"
            (valueChange)="functionalUsageFieldsChangeHandler($event)"
          />
          <atn-ds-select-single
            label="Layout"
            [items]="layoutItems"
            [value]="configuration.functionalUsageLayout"
            [required]="configuration.functionalUsageFields.length > 0"
            [disabled]="configuration.functionalUsageFields.length === 0"
            (valueChange)="
              layoutChangeHandler({ functionalUsageLayout: $event })
            "
          />
        </div>
      </atn-ds-section>
    </div>
  </atn-ds-widget>
</div>
